import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilActionUndo,
  cilBell,
  cilBook,
  cilCalculator,
  cilCalendarCheck,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPaperclip,
  cilPencil,
  cilPuzzle,
  cilReportSlash,
  cilSpeedometer,
  cilStar,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";
import { AUTH_KEY } from "./utils/auth/Authentication";

export const teamComponent = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    authKey: AUTH_KEY.dashboard,
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: "info",
    },
  },
  {
    component: CNavGroup,
    name: "Operasional",
    items: [
      {
        component: CNavItem,
        name: "Rencana Kerja",
        to: "/work-plans",
        authKey: AUTH_KEY.workPlans,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Kunjungan",
        to: "/visitations",
        authKey: AUTH_KEY.visitations,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Report",
    items: [
      {
        component: CNavItem,
        name: "Analisa Toko",
        to: "/store-analytics",
        authKey: AUTH_KEY.analytics,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Analisa Upline",
        to: "/upline-analytics",
        authKey: AUTH_KEY.analytics,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Analisa Stock",
        to: "/stock-analytics",
        authKey: AUTH_KEY.analytics,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Analisa SMD",
        to: "/smd-analytics",
        authKey: AUTH_KEY.analytics,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Catatan Kunjungan",
        to: "/visitation-notes",
        authKey: AUTH_KEY.analytics,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Penerimaan Barang",
      //   to: "/goods-receipts",
      //   authKey: AUTH_KEY.goods_receipts,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Stock Adjustment",
      //   to: "/stock-adjustments",
      //   authKey: AUTH_KEY.stockAdjustments,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      // },
    ],
  },
  {
    component: CNavGroup,
    name: "Master Data",
    items: [
      {
        component: CNavItem,
        name: "Kategori Produk",
        to: "/categories",
        authKey: AUTH_KEY.categories,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Produk",
        to: "/products",
        authKey: AUTH_KEY.products,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: 'Suppliers',
      //   to: '/suppliers',
      //   authKey: AUTH_KEY.suppliers,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />
      // },
      // {
      //   component: CNavItem,
      //   name: 'Customer',
      //   to: '/customers',
      //   authKey: AUTH_KEY.customers,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />
      // },
      {
        component: CNavItem,
        name: "Akun",
        to: "/users",
        authKey: AUTH_KEY.users,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Toko",
        to: "/stores",
        authKey: AUTH_KEY.stores,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Stok",
        to: "/stocks",
        authKey: AUTH_KEY.stocks,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
    ],
  },
];
